import React from 'react'

const ComponentNotFound = ({ blok }) => (
  <div>Component {blok.component} is not defined. Add it to components.js</div>
)

export default ComponentNotFound
